// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".location-contacts button.btn.btn-primary.new-contact{margin:0}.location-contacts table td{width:31%}.location-contacts table td .nameLink{color:#007bff;cursor:pointer}.location-contacts table td.remove{max-width:20px;text-align:center}.location-contacts table td.remove i{cursor:pointer;font-size:14px}", ""]);
// Exports
module.exports = exports;
